/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Add_Members_DescriptionInputs */



/**
* | output |
* | --- |
* | "Add users or teams with specific permissions." |
*
* @param {Spaces_Add_Members_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_add_members_description = /** @type {((inputs?: Spaces_Add_Members_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Add_Members_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer oder Teams mit bestimmten Berechtigungen hinzufügen.")
	return /** @type {LocalizedString} */ ("Add users or teams with specific permissions.")
});